import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useMutation } from 'Data/Api'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import mutation from './mutation.graphql.js'
import debounce from 'lodash/debounce.js'

export default function useListItemDataOnChange(props) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  let emails = useDataValue({
    context: 'emails',
    viewPath: props.viewPath,
  })

  return debounce(onChange, 500)

  async function onChange(next) {
    let email = emails.find(email => email.id === next.id)
    if (email.name !== next.name) {
      await executeMutation({
        comms_email_id: next.id,
        name: next.name,
      })
    }
  }
}
